import { Link } from "react-router-dom";
import { PageHero } from "../components/Layout";
import { useSite } from "../context/SiteContext";
import { useSeo } from "../lib/useSeo";

export default function Privacy() {
  useSeo("Privacy Policy", "How BWI — Built With Intention collects, stores and uses information shared through the enquiry form.");
  const { settings } = useSite();
  const email = settings?.contact?.email;
  const sections = [
    ["What we collect", "When you send an enquiry, we collect the details you provide: your name, brand, email address, phone or WhatsApp number, country, website or Instagram, project information, budget and timeline preferences, and any brief or reference file you choose to upload."],
    ["How we use it", "Your information is used only to respond to your enquiry, prepare a proposal and communicate with you about a potential collaboration. We do not sell or share your details with third parties for marketing."],
    ["Storage and security", "Enquiries and uploaded files are stored securely and are accessible only to the BWI studio owner through a password-protected dashboard. Email notifications are sent through a trusted transactional email provider."],
    ["How long we keep it", "We keep enquiry information for as long as needed to discuss and deliver your project, or until you ask us to delete it."],
    ["Your choices", "You may ask to see, correct or delete the information you have shared at any time by contacting us."],
  ];
  return (
    <>
      <PageHero eyebrow="Legal" testid="privacy-title" title="Privacy Policy" />
      <section className="mx-auto max-w-3xl space-y-12 px-6 pb-32 md:px-10">
        {sections.map(([h, t]) => (
          <div key={h}>
            <h2 className="font-serif text-3xl text-wine">{h}</h2>
            <p className="mt-4 leading-relaxed text-charcoal/85">{t}</p>
          </div>
        ))}
        <p className="leading-relaxed text-charcoal/85">
          Questions? {email ? <a className="text-wine underline" href={`mailto:${email}`}>{email}</a> : <Link className="text-wine underline" to="/contact">Contact us</Link>}
        </p>
      </section>
    </>
  );
}
